import { useEffect, useState } from "react";
import { api, money, dateOnly, API_BASE } from "@/lib/api";
import { Receipt, Download } from "lucide-react";

export default function PortalInvoices() {
    const [list, setList] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get("/portal/invoices");
                if (r?.data) setList(r.data);
            } catch (e) { console.warn(e); }
        })();
    }, []);

    const total = list.reduce((s, i) => s + (i.total || 0), 0);
    const paid = list.reduce((s, i) => s + (i.paid_amount || 0), 0);
    const pending = list.filter((i) => i.status !== "pagado").reduce((s, i) => s + (i.balance || 0), 0);
    const overdue = list.filter((i) => i.days_overdue > 0).reduce((s, i) => s + (i.balance || 0), 0);

    return (
        <div className="space-y-4" data-testid="portal-invoices-page">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <div className="fm-card p-4"><div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Total facturado</div><div className="font-mono font-bold text-xl tabular-nums">{money(total)}</div></div>
                <div className="fm-card p-4 border-l-4 border-l-emerald-500"><div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Pagado</div><div className="font-mono font-bold text-xl tabular-nums text-emerald-700">{money(paid)}</div></div>
                <div className="fm-card p-4 border-l-4 border-l-amber-500"><div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Por pagar</div><div className="font-mono font-bold text-xl tabular-nums">{money(pending)}</div></div>
                <div className="fm-card p-4 border-l-4 border-l-red-600"><div className="text-[10px] uppercase tracking-widest font-bold text-slate-500">Vencido</div><div className="font-mono font-bold text-xl tabular-nums text-red-600">{money(overdue)}</div></div>
            </div>

            <div className="fm-card overflow-hidden">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-200">
                            {["Folio", "Emisión", "Vencimiento", "Subtotal", "IVA", "Total", "Pagado", "Saldo", "Estatus", "PDF"].map((h) => (
                                <th key={h} className="text-left py-2.5 px-3 text-[10px] font-bold text-slate-500 uppercase tracking-wider">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((i) => (
                            <tr key={i.id} className="border-b border-slate-100 hover:bg-slate-50">
                                <td className="py-2 px-3 font-mono text-xs font-bold">{i.folio}</td>
                                <td className="py-2 px-3 text-xs font-mono">{dateOnly(i.issue_date)}</td>
                                <td className="py-2 px-3 text-xs font-mono">
                                    {dateOnly(i.due_date)}
                                    {i.days_overdue > 0 && <span className="text-red-600 ml-1 font-bold">({i.days_overdue}d)</span>}
                                </td>
                                <td className="py-2 px-3 text-right font-mono">{money(i.subtotal)}</td>
                                <td className="py-2 px-3 text-right font-mono text-slate-500">{money(i.iva)}</td>
                                <td className="py-2 px-3 text-right font-mono font-bold">{money(i.total)}</td>
                                <td className="py-2 px-3 text-right font-mono text-emerald-700">{money(i.paid_amount)}</td>
                                <td className="py-2 px-3 text-right font-mono font-bold">{money(i.balance)}</td>
                                <td className="py-2 px-3"><span className={`fm-badge ${i.status === "pagado" ? "fm-badge-positive" : i.status === "pago_parcial" ? "fm-badge-warning" : i.days_overdue > 0 ? "fm-badge-critical" : "fm-badge-neutral"}`}>{i.status}</span></td>
                                <td className="py-2 px-3">
                                    <a href={`${API_BASE}/pdf/invoice/${i.id}`} target="_blank" rel="noreferrer" className="text-slate-700 hover:text-red-600 inline-flex" title="Descargar factura PDF">
                                        <Download className="w-3.5 h-3.5" />
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {list.length === 0 && (
                    <div className="p-10 text-center text-sm text-slate-500">
                        <Receipt className="w-10 h-10 mx-auto mb-2 text-slate-300" strokeWidth={1} />
                        Sin facturas emitidas a la fecha.
                    </div>
                )}
            </div>
        </div>
    );
}
